export default "https://cdn-static-staging.gokick.com/assets/44c43e25e1d60214daaa18ce4b143b941a81a79a/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";